import React from 'react';
import styled from 'styled-components';

const CloseRedIcon = () => {
return(
    <Container>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.1088 16L7.83674 9.96571L3.67347 16H0L6.14966 7.72572L0.380952 0H4.2449L8.13605 5.53143L11.9728 0H15.5646L9.79592 7.72572L16 16H12.1088Z"
                fill="#FC3B4D"/>
        </svg>
    </Container>
)

}
export default CloseRedIcon;

const Container = styled.div`

`;